 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1ANTECEDENT from '@/components/0_chapter1antecedent'
 import A_CHAPTER2AWAKENING from '@/components/1_chapter2awakening'
 import A_CHAPTER3PASTEVENTS from '@/components/2_chapter3pastevents'
 import A_CHAPTER4PAPERCRANE from '@/components/3_chapter4papercrane'
 import A_CHAPTER5UNFORESEEN from '@/components/4_chapter5unforeseen'
 import A_CHAPTER6JADEPENDANT from '@/components/5_chapter6jadependant'
 import A_CHAPTER7SPRINGWATER from '@/components/6_chapter7springwater'
 import A_CHAPTER8MEDICALBOOK from '@/components/7_chapter8medicalbook'
 import A_CHAPTER9NOTES from '@/components/8_chapter9notes'
 import A_CHAPTER10TREATINGDISEASE from '@/components/9_chapter10treatingdisease'
 import A0_CHAPTER11DRAWING from '@/components/10_chapter11drawing'
 import A1_CHAPTER12SLAGMAN from '@/components/11_chapter12slagman'
 import A2_CHAPTER13WHEELCHAIR from '@/components/12_chapter13wheelchair'
 import A3_CHAPTER14SURPRISE from '@/components/13_chapter14surprise'
 import A4_CHAPTER15SPRINGCOLLECTION from '@/components/14_chapter15springcollection'
 import A5_CHAPTER16RIVERLAMP from '@/components/15_chapter16riverlamp'
 import A6_CHAPTER17UPGRADE from '@/components/16_chapter17upgrade'
 import A7_CHAPTER18POETRYCLUB from '@/components/17_chapter18poetryclub'
 import A8_CHAPTER19RANK from '@/components/18_chapter19rank'
 import A9_CHAPTER20OLDWORDS from '@/components/19_chapter20oldwords'
 import A0_CHAPTER21SWAP from '@/components/20_chapter21swap'
 import A1_CHAPTER22STRANGETHING from '@/components/21_chapter22strangething'
 import A2_CHAPTER23UNEXPECTED from '@/components/22_chapter23unexpected'
 import A3_CHAPTER24COINCIDENCE from '@/components/23_chapter24coincidence'
 import A4_CHAPTER25PRISON from '@/components/24_chapter25prison'
 import A5_CHAPTER26TURNAROUND from '@/components/25_chapter26turnaround'
 import A6_CHAPTER27PATROLLING from '@/components/26_chapter27patrolling'
 import A7_CHAPTER28PULSENUMBER from '@/components/27_chapter28pulsenumber'
 import A8_CHAPTER29BROKEN from '@/components/28_chapter29broken'
 import A9_CHAPTER30HERBCOLLECTION from '@/components/29_chapter30herbcollection'
 import A0_CHAPTER31ASSASSIN from '@/components/30_chapter31assassin'
 import A1_CHAPTER32MEDICINALBATH from '@/components/31_chapter32medicinalbath'
 import A2_CHAPTER33SCHEDULE from '@/components/32_chapter33schedule'
 import A3_CHAPTER34PUNISHMENT from '@/components/33_chapter34punishment'
 import A4_CHAPTER35SCHOOL from '@/components/34_chapter35school'
 import A5_CHAPTER36LIE from '@/components/35_chapter36lie'
 import A6_CHAPTER37INSIDE from '@/components/36_chapter37inside'
 import A7_CHAPTER38DOUBTFULMASS from '@/components/37_chapter38doubtfulmass'
 import A8_CHAPTER39FIRE from '@/components/38_chapter39fire'
 import A9_CHAPTER40FLUKE from '@/components/39_chapter40fluke'
 import A0_CHAPTER41SECRETS from '@/components/40_chapter41secrets'
 import A1_CHAPTER42RHINOCEROSHORN from '@/components/41_chapter42rhinoceroshorn'
 import A2_CHAPTER43SITUATION from '@/components/42_chapter43situation'
 import A3_CHAPTER44FRIENDS from '@/components/43_chapter44friends'
 import A4_CHAPTER45FOE from '@/components/44_chapter45foe'
 import A5_CHAPTER46NEWOFFICER from '@/components/45_chapter46newofficer'
 import A6_CHAPTER47NARROWROAD from '@/components/46_chapter47narrowroad'
 import A7_CHAPTER48JEALOUSY from '@/components/47_chapter48jealousy'
 import A8_CHAPTER49HOSPITAL from '@/components/48_chapter49hospital'
 import A9_CHAPTER50SMILE from '@/components/49_chapter50smile'
 import A0_CHAPTER51CONCERN from '@/components/50_chapter51concern'
 import A1_CHAPTER52SOLSTICE from '@/components/51_chapter52solstice'
 import A2_CHAPTER53LYRICS from '@/components/52_chapter53lyrics'
 import A3_CHAPTER54MISSING from '@/components/53_chapter54missing'
 import A4_CHAPTER55PRELIMINARYCOMPETITION from '@/components/54_chapter55preliminarycompetition'
 import A5_CHAPTER56OPENING from '@/components/55_chapter56opening'
 import A6_CHAPTER57STUNNING from '@/components/56_chapter57stunning'
 import A7_CHAPTER58FALLENPHOENIX from '@/components/57_chapter58fallenphoenix'
 import A8_CHAPTER59HIBISCUS from '@/components/58_chapter59hibiscus'
 import A9_CHAPTER60ONETUNE from '@/components/59_chapter60onetune'
 import A0_CHAPTER61PERFORMANCE from '@/components/60_chapter61performance'
 import A1_CHAPTER62BURST from '@/components/61_chapter62burst'
 import A2_CHAPTER63LEGEND from '@/components/62_chapter63legend'
 import A3_CHAPTER64NUDITY from '@/components/63_chapter64nudity'
 import A4_CHAPTER65DEATH from '@/components/64_chapter65death'
 import A5_CHAPTER66PAST from '@/components/65_chapter66past'
 import A6_CHAPTER67HEAVYRAIN from '@/components/66_chapter67heavyrain'
 import A7_CHAPTER68TRUTH from '@/components/67_chapter68truth'
 import A8_CHAPTER69END from '@/components/68_chapter69end'
 import A9_CHAPTER70PEACHFLOWER from '@/components/69_chapter70peachflower'
 import A0_CHAPTER71TEMPLE from '@/components/70_chapter71temple'
 import A1_CHAPTER72ESCAPE from '@/components/71_chapter72escape'
 import A2_CHAPTER73TRAP from '@/components/72_chapter73trap'
 import A3_CHAPTER74CLOSING from '@/components/73_chapter74closing'
 import A4_CHAPTER75DISCIPLE from '@/components/74_chapter75disciple'
 import A5_CHAPTER76BODYPROTECTION from '@/components/75_chapter76bodyprotection'
 import A6_CHAPTER77EXTERMINATION from '@/components/76_chapter77extermination'
 import A7_CHAPTER78ENIGMA from '@/components/77_chapter78enigma'
 import A8_CHAPTER79PAST from '@/components/78_chapter79past'
 import A9_CHAPTER80WILL from '@/components/79_chapter80will'
 import A0_CHAPTER81AMOROUSFEELINGS from '@/components/80_chapter81amorousfeelings'
 import A1_CHAPTER82MATCHMAKING from '@/components/81_chapter82matchmaking'
 import A2_CHAPTER83DRINKING from '@/components/82_chapter83drinking'
 import A3_CHAPTER84DANGER from '@/components/83_chapter84danger'
 import A4_CHAPTER85EXCUSE from '@/components/84_chapter85excuse'
 import A5_CHAPTER86DREAM from '@/components/85_chapter86dream'
 import A6_CHAPTER87DEATH from '@/components/86_chapter87death'
 import A7_CHAPTER88NATURALDISASTER from '@/components/87_chapter88naturaldisaster'
 import A8_CHAPTER89TOMBSTONE from '@/components/88_chapter89tombstone'
 import A9_CHAPTER90CHEAPATTACK from '@/components/89_chapter90cheapattack'
 import A0_CHAPTER91ENCOUNTER from '@/components/90_chapter91encounter'
 import A1_CHAPTER92ACQUAINTANCE from '@/components/91_chapter92acquaintance'
 import A2_CHAPTER93GUIDANCE from '@/components/92_chapter93guidance'
 import A3_CHAPTER94LENGTH from '@/components/93_chapter94length'
 import A4_CHAPTER95COOKING from '@/components/94_chapter95cooking'
 import A5_CHAPTER96WILDSILKWORM from '@/components/95_chapter96wildsilkworm'
 import A6_CHAPTER97GENESIS from '@/components/96_chapter97genesis'
 import A7_CHAPTER98SILK from '@/components/97_chapter98silk'
 import A8_CHAPTER99HARVEST from '@/components/98_chapter99harvest'
 import A9_CHAPTER100SPOILAGE from '@/components/99_chapter100spoilage'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1antecedent",
 			"name" : "0_chapter1antecedent",
 			"component" : A_CHAPTER1ANTECEDENT
 		},
 		{
 			"path" : "/1_chapter2awakening",
 			"name" : "1_chapter2awakening",
 			"component" : A_CHAPTER2AWAKENING
 		},
 		{
 			"path" : "/2_chapter3pastevents",
 			"name" : "2_chapter3pastevents",
 			"component" : A_CHAPTER3PASTEVENTS
 		},
 		{
 			"path" : "/3_chapter4papercrane",
 			"name" : "3_chapter4papercrane",
 			"component" : A_CHAPTER4PAPERCRANE
 		},
 		{
 			"path" : "/4_chapter5unforeseen",
 			"name" : "4_chapter5unforeseen",
 			"component" : A_CHAPTER5UNFORESEEN
 		},
 		{
 			"path" : "/5_chapter6jadependant",
 			"name" : "5_chapter6jadependant",
 			"component" : A_CHAPTER6JADEPENDANT
 		},
 		{
 			"path" : "/6_chapter7springwater",
 			"name" : "6_chapter7springwater",
 			"component" : A_CHAPTER7SPRINGWATER
 		},
 		{
 			"path" : "/7_chapter8medicalbook",
 			"name" : "7_chapter8medicalbook",
 			"component" : A_CHAPTER8MEDICALBOOK
 		},
 		{
 			"path" : "/8_chapter9notes",
 			"name" : "8_chapter9notes",
 			"component" : A_CHAPTER9NOTES
 		},
 		{
 			"path" : "/9_chapter10treatingdisease",
 			"name" : "9_chapter10treatingdisease",
 			"component" : A_CHAPTER10TREATINGDISEASE
 		},
 		{
 			"path" : "/10_chapter11drawing",
 			"name" : "10_chapter11drawing",
 			"component" : A0_CHAPTER11DRAWING
 		},
 		{
 			"path" : "/11_chapter12slagman",
 			"name" : "11_chapter12slagman",
 			"component" : A1_CHAPTER12SLAGMAN
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js